import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";

/**
 * Inline scarcity micro-element near primary CTA.
 * City is auto-detected via IP geolocation; falls back to "your area".
 * Enrollment count is editable below — update monthly.
 */
const MONTHLY_ENROLLMENTS = 47; // EDIT MONTHLY

const ZipScarcityLine = ({ className = "" }: { className?: string }) => {
  const [city, setCity] = useState<string>("your area");

  useEffect(() => {
    let cancelled = false;
    // Try cached value first to avoid re-fetching
    try {
      const cached = sessionStorage.getItem("ceag_detected_city");
      if (cached) {
        setCity(cached);
        return;
      }
    } catch {
      /* ignore */
    }

    // Lightweight IP geo — no key, CA-safe fallback
    fetch("https://ipapi.co/json/")
      .then((r) => r.ok ? r.json() : null)
      .then((data) => {
        if (cancelled || !data) return;
        if (data.region_code === "CA" && data.city) {
          setCity(data.city);
          try { sessionStorage.setItem("ceag_detected_city", data.city); } catch { /* ignore */ }
        }
      })
      .catch(() => { /* keep fallback */ });

    return () => { cancelled = true; };
  }, []);

  return (
    <p className={`flex items-center justify-center lg:justify-start gap-1.5 text-xs font-medium text-foreground/80 ${className}`}>
      <MapPin className="h-3.5 w-3.5 text-secondary" aria-hidden="true" />
      <span>
        <strong className="text-foreground">{MONTHLY_ENROLLMENTS} homeowners</strong> in{" "}
        <strong className="text-foreground">{city}</strong> enrolled this month —
        is your ZIP still open?
      </span>
    </p>
  );
};

export default ZipScarcityLine;
